<template>
  <div class="tw-min-w-[1200px]">
    <AdministrationTableHeader
      :columns="columns"
      :store-path="storePath"
      filters-mutation-relative-path="updateFilter"
      filters-state-relative-path="filters"
    />

    <div class="tw-mb-8 tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl">
      <template
        v-for="(item, index) in itemsList"
        :key="item.id"
      >
        <div
          v-if="index > 0"
          class="tw-w-full tw-h-px tw-bg-gray dark:tw-bg-dm-gray"
        />
        <component
          :is="listItemComponentName"
          v-bind="{ [listItemPropName]: item }"
          :columns="columns"
        />
      </template>
    </div>
  </div>
</template>

<script>
import AgencyCompaniesListItem from '@/components/Administration/Agency/Companies/AgencyCompaniesListItem.vue';
import ClientCompaniesListItem from '@/components/Administration/Client/Companies/ClientCompaniesListItem.vue';
import AdministrationTableHeader from '@/components/Administration/components/AdministrationTableHeader.vue';
import AgencyUsersListItem from '@/components/Administration/Agency/Users/AgencyUsersListItem.vue';
import ClientsUsersListItem from '@/components/Administration/Client/Users/ClientsUsersListItem.vue';
import InternalUsersListItem from '@/components/Administration/Internal/Users/InternalUsersListItem.vue';
import InternalPlacesListItem from '@/components/Administration/Internal/Places/InternalPlacesListItem.vue';
import InternalFaqListItem from '@/components/Administration/Internal/Faq/InternalFaqListItem.vue';
import PermitDocumentListItem from '@/components/Administration/PermitManagement/Documents/PermitDocumentListItem.vue';
import PermitActionDateListItem
  from '@/components/Administration/PermitManagement/ActionDates/PermitActionDateListItem.vue';
import PermitStatusListItem from '@/components/Administration/PermitManagement/Statuses/PermitStatusListItem.vue';
import PermitTypeListItem from '@/components/Administration/PermitManagement/PermitTypes/PermitTypeListItem.vue';

export default {
  name: 'CompaniesList',
  components: {
    AdministrationTableHeader,
    AgencyCompaniesListItem,
    ClientCompaniesListItem,
    AgencyUsersListItem,
    ClientsUsersListItem,
    InternalUsersListItem,
    InternalPlacesListItem,
    InternalFaqListItem,
    PermitDocumentListItem,
    PermitActionDateListItem,
    PermitStatusListItem,
    PermitTypeListItem,
  },
  props: {
    listItemComponentName: {
      type: String,
      required: true,
    },
    listItemPropName: {
      type: String,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    storePath: {
      type: String,
      required: true,
    },
    listRelativePath: {
      type: String,
      required: true,
    },
  },
  computed: {
    itemsList() {
      return this.getPathState(`${this.storePath}/${this.listRelativePath}`);
    },
  },
  methods: {
    getPathState(path) {
      return path.split('/').reduce((acc, part) => acc[part], this.$store.state);
    },
  },
};
</script>
